(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gamble-cart"]) return;
  try {
    
(() => {
  const form = document.getElementById('GambleCart');
  if (!form) return;
  form.querySelectorAll('[data-gc-quantity-step]').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      const value = parseInt(input.value, 10);
      input.value = Math.max(0, (Number.isFinite(value) ? value : 1) + Number(button.dataset.gcQuantityStep));
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gamble-release-archive"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialise(root) {
    if (root.dataset.gcReleaseReady) return;
    root.dataset.gcReleaseReady = 'true';
    const filters = root.querySelector('.gc-release-filters');
    const buttons = [...filters.querySelectorAll('button')];
    const cards = [...root.querySelectorAll('.gc-release-card')];
    const count = root.querySelector('[data-gc-release-count]');
    count.textContent = cards.length;
    filters.hidden = false;
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-gc-release-filter]');
      if (!button) return;
      const filter = button.dataset.gcReleaseFilter;
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      let visible = 0;
      cards.forEach(card => {
        card.hidden = filter !== 'all' && card.dataset.gcReleaseState !== filter;
        if (!card.hidden) visible += 1;
      });
      count.textContent = visible;
    });
    root.addEventListener('shopify:block:select', event => {
      if (event.target.hidden) buttons[0].click();
    });
  }
  document.querySelectorAll('[data-gc-release-archive]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gc-release-archive]').forEach(initialise));
})();

  } catch(e) { console.error(e); }
})();
})();
